import { useCallback, useMemo } from 'react'
import { canModifyBooking, canOpenBooking, PERMISSIONS, SCHOOL_DEPARTMENTS, SCHOOL_PERMISSIONS, type AccessibleBooking } from '@jupi/shared'
import { useAuth } from '@jupi/ui'

// What the signed-in member may do with a booking, for the pages to decide
// what to offer (the API enforces the same).
export function useBookingAccess() {
  const { user, can } = useAuth()
  const viewer = useMemo(
    () => ({
      userId: user?.id ?? '',
      canManageAny: can(PERMISSIONS.bookingManageAny),
      canManageOwn: can(PERMISSIONS.bookingManageOwn),
      canMaintain: can(PERMISSIONS.maintenanceWrite),
      canInstruct: SCHOOL_DEPARTMENTS.some((d) => can(SCHOOL_PERMISSIONS[d].instruct)),
    }),
    [user?.id, can],
  )
  const canOpen = useCallback((booking: AccessibleBooking) => canOpenBooking(booking, viewer), [viewer])
  const canModify = useCallback((booking: AccessibleBooking) => canModifyBooking(booking, viewer, new Date()), [viewer])
  return { canOpen, canModify }
}
